import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { BaseVariableListBlockComponent } from '../../../common/base-variable-list-block.component';

@Component({
    selector: 'app-headline',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './headline.component.html'
})
export class HeadlineComponent extends BaseVariableListBlockComponent {
  protected readonly variablePrefix = 'Headline';
  minVariables = 3;
  maxVariables = 15;

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: string): void {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent): void {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
